import React from "react";
import { Icon } from "@alifd/next";
import styles from "./index.module.scss";

interface TagItem {
  id: string;
  name: string;
  description?: string; // 可选属性
}

const ContentDiv = (tagItem: TagItem): JSX.Element => {
  return (
    <div>
      <div style={{ fontSize: "14px", fontWeight: "bold" }}>{tagItem.name}</div>
      <div>{tagItem.description || "无描述"}</div> {/* 处理可能的 undefined */}
    </div>
  );
};

interface TagMappingCrowdProps {
  activeTagList: TagItem[];
  changeActiveList: (item: TagItem, index: number, action: string) => void;
}

const TagMappingCrowd: React.FC<TagMappingCrowdProps> = ({ activeTagList = [], changeActiveList = () => {} }) => {
  return (
    <>
      {activeTagList.map((subItem, subIndex) => (
        <div key={`contItem_${subIndex}`}>
          {/* <div className={`${styles['tag-title']}`}>
            <span>人群包</span>
          </div> */}
          <section className={`${styles["tag-content"]}`}>
            <div key={`subItem_${subIndex}`}>
              <div key={subItem.id} className={`${styles.mb10}`}>
                <section className={`${styles["tag-name"]}`} style={{ position: "relative" }}>
                  <span>人群包</span>
                  <Icon
                    onClick={(event) => {
                      changeActiveList(subItem, subIndex, "del");
                    }}
                    type="close"
                    size="xs"
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      top: "5px",
                      right: "15px",
                    }}
                  />
                </section>
                <div className={`${styles["editTag-content"]}`}>{ContentDiv(subItem)}</div>
              </div>
            </div>
          </section>
        </div>
      ))}
    </>
  );
};

export default TagMappingCrowd;
